import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {DataTablesResponse} from '../models/dataTables-response';
import {webServiceConfig} from '../config/web-service.config';
import {map} from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class ProductService {

    constructor(private http: HttpClient) {
    }

    getDatatable(dataTablesParameters): Observable<any> {
        return this.http.post<DataTablesResponse>(`${webServiceConfig.webServiceUrl}products/datatable`, dataTablesParameters, {})
            .pipe(map(response => {
                return response;
            }));
    }

    getAll(): Observable<any> {
        return this.http.get(`${webServiceConfig.webServiceUrl}products`).pipe(map(response => {
            return response;
        }));
    }

    getById(productId: number): Observable<any> {
        return this.http.get(`${webServiceConfig.webServiceUrl}products/${productId}`).pipe(map(response => {
            return response;
        }));
    }

    store(product: any): Observable<any> {
        return this.http.post(`${webServiceConfig.webServiceUrl}products`, product)
            .pipe(map(response => {
                return response;
            }));
    }

    update(product: any): Observable<any> {
        return this.http.put(`${webServiceConfig.webServiceUrl}products/${product.id}`, product)
            .pipe(map(response => {
                return response;
            }));
    }

    delete(id: number): Observable<any> {
        return this.http.delete(`${webServiceConfig.webServiceUrl}products/${id}`)
            .pipe(map(response => {
                return response;
            }));
    }
}
